import { takeLatest, put, call, select } from "redux-saga/effects";
import get from "lodash.get";

import types from "actions/actionTypes";
import { fetchUserAttributes } from "./Api";
import fetchSaga from "./fetchSaga";
import { getCurrentExternalId } from "selector/userSelectors";
import { changeWorklistFilter } from "actions/fetchWorkItemsActions";
import { showLoader, hideLoader } from "actions/soleraLoaderActions";

const mapExternalIdsString = string => {
  if (string.trim().length === 0) {
    return [];
  }

  return string.split(",").map(pair => {
    const [id, name] = pair.split("|");
    return { id, name };
  });
};

export function* getUserAttributes() {
  try {
    yield put(showLoader());
    const response = yield call(fetchSaga, fetchUserAttributes);
    yield put(hideLoader());

    const currentExternalId = yield select(getCurrentExternalId);
    const externalIds = mapExternalIdsString(
      get(response, "preferences.attributes.externalIds", "")
    );
    const currentIsInOptions =
      currentExternalId &&
      externalIds.some(({ id }) => id === currentExternalId.id);
    const externalId = currentIsInOptions ? currentExternalId : externalIds[0];

    const attributes = {
      clientName: get(response, "preferences.attributes.companyName"),
      externalIds,
      externalId
    };
    if (externalId) {
      yield put(
        changeWorklistFilter({ name: "ExternalId", value: externalId.id })
      );
    }
    yield put({ type: types.SET_USER_ATTRIBUTES, payload: attributes });
  } catch (err) {
    yield put({
      type: types.GET_USER_ATTRIBUTES_ERROR,
      error: true,
      payload: err.toString()
    });
  }
}

export default [takeLatest(types.GET_USER_ATTRIBUTES, getUserAttributes)];
